import TableDynamic from "../../../components/TableDynamic";
import React from "react";
import { Button, Card, Alert, Spinner } from "react-bootstrap";
import { store } from "../../../reducer/Store";
import ModalFormRegisterOrUpdate from "../../../components/ModalFormRegisterOrUpdate";
import ApiService from "../../../services/ApiService";
const Interlocutors = ({ refreshTab }) => {
  const { dispatch, state } = React.useContext(store);
  const [showUpdateKam, setShowUpdateKam] = React.useState(false);
  const [showRegisterKam, setShowRegisterKam] = React.useState(false);
  const [lastname, setLastname] = React.useState("");
  const [firstname, setFirstname] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [kamId, setKamId] = React.useState("");
  const [phoneNbr, setPhoneNbr] = React.useState("");
  //const [loader, setLoader] = React.useState(false);
  const columnsName = ["Fonction", "Nom", "Prénom", "Téléphone", "Email", ""];
  const columns = [
    "interlocutor_role",
    "lastname",
    "firstname",
    "phone",
    "email",
    "updateAndDelete",
  ];
  const columnsName2 = ["Fonction", "Nom", "Prénom", "Téléphone", "Email"];
  const columns2 = [
    "interlocutor_role",
    "lastname",
    "firstname",
    "phone",
    "email",
  ];

  const handleClose = () => {
    setShowUpdateKam(false);
    setShowRegisterKam(false);
    setFirstname("");
    setLastname("");
    setEmail("");
    setPhoneNbr("");
  };

  const handleRegisterKam = () => setShowRegisterKam(true);

  /**
   * Cette fonction permet de gérer la mise à jour des informations d'un Key Account Manager (KAM) en remplissant les champs du formulaire avec les informations existantes du KAM.
   * @param {Object} kam - L'objet KAM contenant les informations du KAM à mettre à jour.
   */
  const handleUpdateKam = (kam) => {
    setFirstname(kam.firstname);
    setLastname(kam.lastname);
    setEmail(kam.email);
    setPhoneNbr(kam.phone);
    setKamId(kam.id);
    setShowUpdateKam(true);
  };

  /**
   * Cette fonction récupère les interlocuteurs KAM pour un client sélectionné et une année donnée.
   */
  const getInterlocutorKamCustomer = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `interlocutors-kams-by-customer-year/${state.dataSelectedClient.id}/${state.currentYear.value}`,
      "get"
    )
      .then(function (response) {
        dispatch({
          type: "SET_INTERLOCUTORKAMCUSTOMER",
          payload: response.data,
        });
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction récupère les interlocuteurs d'une équipe associée à un ensemble de marques et un client spécifique pour une année donnée. Elle met à jour la liste des interlocuteurs et le loader de l'application.
   */
  const getInterlocutorsCustomer = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    var brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );
    ApiService.request(
      {},
      `interlocutors-team-by-brand-customer-year/${brands}/${state.dataSelectedClient.id}/${state.currentYear.value}`,
      "get"
    )
      .then(function (response) {
        dispatch({
          type: "SET_LISTINTERLOCUTORSCUSTOMER",
          payload: response.data,
        });
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction met à jour les informations d'un interlocuteur de type KAM (Key Account Manager) pour le client sélectionné.
   * @param { String } lastname - Le nom de famille de l'interlocuteur KAM.
   * @param { String } firstname - Le prénom de l'interlocuteur KAM.
   * @param { String } email - L'adresse e-mail de l'interlocuteur KAM.
   * @param { String } phoneNbr - Le numéro de téléphone de l'interlocuteur KAM.
   * @param { Number } kamId - L'identifiant de l'interlocuteur KAM à mettre à jour.
   * @param { Number } year_id - L'année à laquelle se rattacher.
   * @param { Number } interlocutor_role_id - Le rôle de l'interlocuteur Kam.
   * @param { Number } state.dataSelectedClient.id - Le client sélectionné qui a ce KAM.
   */
  const updateInterlocutorKam = () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        lastname: lastname,
        firstname: firstname,
        email: email,
        phone: phoneNbr,
        year_id: state.currentYear.value,
        customer_id: state.dataSelectedClient.id,
        interlocutor_role_id: 1,
      },
      `interlocutors/${kamId}`,
      "put"
    )
      .then(function () {
        handleClose();
        getInterlocutorKamCustomer();
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction enregistre un nouvel interlocuteur Kam pour le client en cours.
   * @param { String } lastname - Le nom de famille de l'interlocuteur Kam.
   * @param { String } firstname - Le prénom de l'interlocuteur Kam.
   * @param { String } email - L'adresse email de l'interlocuteur Kam.
   * @param { String } phoneNbr - Le numéro de téléphone de l'interlocuteur Kam.
   * @param { Number } year_id - L'année à laquelle se rattacher.
   * @param { Number } interlocutor_role_id - Le rôle de l'interlocuteur Kam.
   * @param { Number } state.dataSelectedClient.id - Le client sélectionné qui aura ce KAM.
   */
  const registerInterlocutorKam = () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        lastname: lastname,
        firstname: firstname,
        email: email,
        phone: phoneNbr,
        interlocutor_role_id: 1,
        year_id: state.currentYear.value,
        customer_id: state.dataSelectedClient.id,
      },
      `interlocutors`,
      "post"
    )
      .then(function () {
        handleClose();
        getInterlocutorKamCustomer();
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction supprime un KAM (Key Account Manager) de l'application.
   * @param { Object } kam - L'objet représentant le KAM à supprimer.
   */
  const deleteInterlocutorKam = (kam) => {
    if (
      window.confirm(
        "Êtes vous sûr de vouloir supprimer ce KAM " +
          kam.lastname +
          " " +
          kam.firstname +
          " ?"
      )
    ) {
      dispatch({ type: "SET_LOADER", payload: true });
      ApiService.request({}, "interlocutors/" + kam.id, "delete")
        .then(function () {
          dispatch({ type: "SET_LOADER", payload: false });
          getInterlocutorKamCustomer();
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  React.useEffect(() => {
    if (state.dataSelectedClient && state.dataSelectedClient.id) {
      getInterlocutorKamCustomer();
      if (state.currentBrands && state.currentBrands.length > 0) {
        getInterlocutorsCustomer();
      } else {
        dispatch({
          type: "SET_LISTINTERLOCUTORSCUSTOMER",
          payload: [],
        });
      }
    }
  }, [
    state.dataSelectedClient,
    state.currentBrands,
    state.currentYear.value,
    refreshTab,
  ]);

  return (
    <div className="">
      {state.interlocutorKamCustomer &&
      state.interlocutorKamCustomer.length === 0 ? (
        <div className="card position-relative mt-5">
          <div className="card-title h5">Aucun KAM renseigné</div>
          {(parseInt(localStorage.getItem("user_role")) !== 5 &&
            parseInt(localStorage.getItem("user_role")) !== 6) && (
            <Button
              onClick={() => {
                handleRegisterKam();
              }}
              className="button-add is-top-right btn btn-primary"
            >
              Ajouter un KAM
            </Button>
          )}
        </div>
      ) : (
        <TableDynamic
          showUpdate={handleUpdateKam}
          deleteD={deleteInterlocutorKam}
          columnsName={columnsName}
          columns={columns}
          data={state.interlocutorKamCustomer}
          customClassName={"mt-1"}
          controlTableId={"KamNotResponsive"}
        ></TableDynamic>
      )}

      <div className="mb-3"></div>
      {state.currentBrands.length > 0 ? (
        <>
          {!state.loader ? (
            state.listInterlocutorsCustomer &&
            state.listInterlocutorsCustomer.map(
              (teamInterlocutorCustomer, i) => (
                <div key={i + "-team"} className="mb-4">
                  <span
                    style={{
                      backgroundColor: teamInterlocutorCustomer[0].brand.color,
                      padding: "5px",
                    }}
                    className="rounded white marque"
                  >
                    {teamInterlocutorCustomer[0].brand.name}
                  </span>
                  <TableDynamic
                    key={i + "-table"}
                    columnsName={columnsName2}
                    columns={columns2}
                    data={teamInterlocutorCustomer}
                    customClassName={"bg-yellow-user"}
                    controlTableId={"interlocutors"}
                  ></TableDynamic>
                </div>
              )
            )
          ) : (
            <div className="text-center pt-5">
              <Spinner
                animation={state.loader ? "border" : false}
                role="status"
              ></Spinner>
            </div>
          )}
        </>
      ) : (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner au moins une marque.
            </Alert>
          </Card.Body>
        </Card>
      )}

      {showUpdateKam && (
        <ModalFormRegisterOrUpdate
          show={showUpdateKam}
          registerOrUpdate={updateInterlocutorKam}
          name={firstname}
          lastname={lastname}
          email={email}
          phoneNbr={phoneNbr}
          setEmail={setEmail}
          setName={setFirstname}
          setLastname={setLastname}
          setPhoneNbr={setPhoneNbr}
          handleClose={handleClose}
          controlFormId={"update-kam"}
        />
      )}

      {showRegisterKam && (
        <ModalFormRegisterOrUpdate
          show={showRegisterKam}
          registerOrUpdate={registerInterlocutorKam}
          name={firstname}
          lastname={lastname}
          email={email}
          phoneNbr={phoneNbr}
          setEmail={setEmail}
          setName={setFirstname}
          setLastname={setLastname}
          setPhoneNbr={setPhoneNbr}
          handleClose={handleClose}
          controlFormId={"register-kam"}
        />
      )}
    </div>
  );
};

export default Interlocutors;
